export default __webpack_public_path__ + "static/media/lilfrankies.0296092a.jpeg";